import * as React from "react";

interface FacebookIconProps {
	iconColor: string;
	style: any;
	onClick?: () => void;
}

const FacebookIcon = (props: FacebookIconProps) => (
	<svg
		width="25px"
		height="38px"
		viewBox="0 0 20 40"
		version="1.1"
		style={props.style}
		onClick={props.onClick}
	>
		<g
			id="1440x-1024"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
			transform="translate(-707.000000, -922.000000)"
		>
			<g
				id="Social-Media-Icons"
				transform="translate(518.000000, 922.000000)"
				fill={props.iconColor}
				fillRule="nonzero"
			>
				<path
					d="M212.658021,0.00920995973 L206.917914,0 C200.4691,0 196.301593,4.2757238 196.301593,10.8935404 L196.301593,15.9161919 L190.530172,15.9161919 C190.031453,15.9161919 189.627596,16.3205091 189.627596,16.8192285 L189.627596,24.0964781 C189.627596,24.5951974 190.031913,24.9990542 190.530172,24.9990542 L196.301593,24.9990542 L196.301593,43.3618719 C196.301593,43.8605912 196.70545,44.2644479 197.204169,44.2644479 L204.734232,44.2644479 C205.232952,44.2644479 205.636808,43.8601307 205.636808,43.3618719 L205.636808,24.9990542 L212.384946,24.9990542 C212.883665,24.9990542 213.287522,24.5951974 213.287522,24.0964781 L213.290285,16.8192285 C213.290285,16.5797695 213.194962,16.3504415 213.025959,16.1809782 C212.856956,16.011515 212.626707,15.9161919 212.387248,15.9161919 L205.636808,15.9161919 L205.636808,11.6584275 C205.636808,9.61197447 206.124476,8.57309101 208.790299,8.57309101 L212.6571,8.57170952 C213.155359,8.57170952 213.559216,8.16739228 213.559216,7.66913346 L213.559216,0.911786013 C213.559216,0.41398769 213.15582,0.0101309557 212.658021,0.00920995973 Z"
					id="Shape"
				/>
			</g>
		</g>
	</svg>
);

export default FacebookIcon;



// WEBPACK FOOTER //
// ./src/components/Footer/FacebookIcon.tsx